import { palette } from '../design-system/colors';
import styled, { css } from 'styled-components';
import { rgba } from 'polished';

// wrap an image with video thumbnail in this wrapper, it will slightly darken the image and place a play button over it
export const VideoThumbnailWrapper = styled.div`
    position: relative;
    border-radius: 4px;
    cursor: pointer;
    ${(props) =>
        props.fullWidth &&
        css`
            width: 100%;
        `}

    &:after {
        position: absolute;
        border-radius: 4px;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: ease 0.2s all;
        content: '';
        background-image: url('/static/img/icon-play.png');
        background-repeat: no-repeat;
        background-size: 30px auto;
        background-position: center center;
        background-color: ${rgba(palette.graphite.heavyMetal, 0.2)};
    }
`;
